import React from 'react'
import { Alert, Snackbar } from '@mui/material'
import type { NotificationProps } from '@/types/common/notification'

const zIndex = 2000

// eslint-disable-next-line react/display-name
export const Notification: React.FC<NotificationProps> = React.memo((props) => {
  const { notification, setNotification } = props
  const handleClose = () => {
    setNotification({ ...notification, open: false })
  }
  return (
    <>
      <Snackbar
        open={notification.open}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        // autoHideDuration={5000}
        // onClose={handleClose}
        sx={{ zIndex, whiteSpace: 'pre-line' }}
      >
        <Alert onClose={handleClose} severity={notification.severity}>
          {notification.msg}
        </Alert>
      </Snackbar>
    </>
  )
})
